<template>
    <div class="management">
        <div class="row">
            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="skills-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectSchools">
                    <b-button
                        class="btn-school remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="skills-card-body body">
                        <b-card-title title-tag="h5">{{ $t('admin.schools') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('admin.list_of_all_schools_choose_a_school_to_go_further') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="profile-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectAccounts">
                    <b-button
                        class="btn-account remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="profile-card-body body">
                        <b-card-title title-tag="h5">{{ $t('common.accounts') }}</b-card-title>
                        <div class="muted-text">
                            {{
                                $t(
                                    'admin.index_search_in_all_accounts_in_the_portal_and_take_over_an_account_if_necessary',
                                )
                            }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectOrganizations">
                    <b-button
                        class="btn-university remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">{{ $t('organization.organizations') }}</b-card-title>
                        <div class="muted-text">
                            {{
                                $t(
                                    'admin.modal.index.manage_access_to_portfolio_assignments_for_external_organisations',
                                )
                            }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectSkills">
                    <b-button
                        class="btn-user-chart remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">{{ $t('admin.skills') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('admin.standard_sets_of_skills_available_for_each_school_in_the_portal') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectMagazines">
                    <b-button
                        class="btn-book-open remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">Magazines</b-card-title>
                        <div class="muted-text">
                            {{ $t('admin.find_the_list_of_magazines_by_deadline_and_status_here') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectYearbooks">
                    <b-button
                        class="btn-yearbook remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">{{ $t('admin.yearbooks') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('admin.find_the_list_of_yearbooks_by_deadline_and_status_here') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectAfscheidsboekjes">
                    <b-button
                        class="btn-duo-open-book remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">{{ $t('admin.farewell_booklets') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('admin.find_the_list_of_farewell_booklets_by_deadline_and_status_here') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectTemplates">
                    <b-button
                        class="btn-templates remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">{{ $t('admin.templates') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('admin.manage_the_templates_that_schools_can_use_here') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectCopyProjects">
                    <b-button
                        class="btn-copy remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">{{ $t('admin.project_for_school_copy') }} </b-card-title>
                        <div class="muted-text">{{ $t('admin.project_for_school_copy_description') }}</div>
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectImages">
                    <b-button
                        class="btn-images remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">{{ $t('admin.images') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('admin.manage_the_images_that_schools_can_use') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectAFAQ">
                    <b-button
                        class="btn-question-circle remove-icon-margin fa-4x"
                        variant="primary-icon-only">
                    </b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">{{ $t('admin.faq') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('admin.find_the_faq_editor_from_the_portal_here') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectLists">
                    <b-button
                        class="btn-list remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">{{ $t('admin.lists') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('admin.find_various_lists_with_information_from_the_portal_here') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectOrders">
                    <b-button
                        class="btn-clipboard remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">{{ $t('admin.orders') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('admin.find_here_all_orders_for_papers_that_have_been_placed_including_status') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div
                class="col-12 col-md-6 col-lg-3"
                v-if="$authUser.hasRole('super')">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectAdminAccounts()">
                    <b-button
                        class="btn-account remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">Admin accounts</b-card-title>
                        <div class="muted-text">
                            {{ $t('admin.edit_admin_accounts') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectDeadlines">
                    <b-button
                        class="btn-clock remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">Deadlines</b-card-title>
                        <div class="muted-text">
                            {{ $t('admin.find_here_all_deadlines') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectInternship">
                    <b-button
                        class="btn-table-head remove-icon-margin fa-4x"
                        variant="primary-icon-only">
                    </b-button>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">{{ $t('admin.internship_bank') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('admin.manage_all_public_internships_from_the_apprentice_internship_bank_here') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectLasImports">
                    <b-button
                        class="btn-link-before remove-icon-margin fa-4x"
                        variant="primary-icon-only"></b-button>
                    <b-card-body body-class="las-card-body body">
                        <b-card-title title-tag="h5">Las Error Logs</b-card-title>
                        <div class="muted-text">
                            {{ $t('admin.view_las_import_error_logs_here') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectBadges">
                    <b-button
                        class="btn-duo-spade remove-icon-margin fa-4x"
                        variant="primary-icon-only">
                    </b-button>
                    <b-card-body body-class="las-card-body body">
                        <b-card-title title-tag="h5">Badges</b-card-title>
                        <div class="muted-text">
                            {{ $t('admin.edit_badges') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <b-card
                    class="module-card apprentice-simple-card-with-banner card-icon-styling"
                    no-body
                    @click="redirectAnalytics">
                    <b-button
                        class="btn-line-graph remove-icon-margin fa-4x"
                        variant="primary-icon-only">
                    </b-button>
                    <b-card-body body-class="las-card-body body">
                        <b-card-title title-tag="h5">{{ $t('admin.analytics') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('admin.analytics_management') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-admin-index-component',
    methods: {
        redirectDeadlines() {
            window.location.href = this.routes.deadlines();
        },

        redirectAdminAccounts() {
            window.location.href = this.routes.adminAccounts();
        },

        redirectSchools() {
            window.location.href = this.routes.schools();
        },

        redirectAccounts() {
            window.location.href = this.routes.accounts();
        },

        redirectOrganizations() {
            window.location.href = this.routes.organizations();
        },

        redirectSkills() {
            window.location.href = this.routes.defaultSkills();
        },

        redirectMagazines() {
            window.location.href = this.routes.magazines();
        },

        redirectYearbooks() {
            window.location.href = this.routes.yearbooks();
        },

        redirectAfscheidsboekjes() {
            window.location.href = this.routes.afscheidsboekjes();
        },

        redirectTemplates() {
            window.location.href = this.routes.templates();
        },

        redirectImages() {
            window.location.href = this.routes.images();
        },
        redirectCopyProjects() {
            window.location.href = this.routes.adminCopyGroups();
        },

        redirectLists() {
            window.location.href = this.routes.lists();
        },

        redirectOrders() {
            window.location.href = this.routes.orders();
        },
        redirectAFAQ() {
            window.location.href = this.routes.adminAFAQ();
        },
        redirectInternship() {
            window.location.href = this.routes.internshipDatabase();
        },
        redirectLasImports() {
            window.location.href = this.routes.adminLas();
        },

        redirectBadges() {
            window.location.href = this.routes.adminBadges();
        },

        redirectAnalytics() {
            window.location.href = this.routes.adminAnalytics();
        }
    },
};
</script>

<style scoped lang="scss">
.management {
    .row {
        > div {
            margin-bottom: $grid-gutter-width;
        }
    }
}
</style>
